import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {scrollToElementById} from '@/module/utils';


@Component({components:{}})
export default class AlegereSaTeImplici extends Vue {
    loading:boolean=false;
    evenimentMobilSlide='alimente';

    $refs:any;
    private userStore=getModule(User);



    constructor(){
        super();
    }

    goToNewList(){
        scrollToElementById('img_logo_site',0,300);
        this.$router.push({name: 'new_gifts_list'});
    }

    handleSwipeNextPrevPage ({ evt, ...info }:any) {
        let vueInst=this;
        if(info.direction=='up'){//prev Page
            scrollToElementById('div_footer',-17,300);
        }
        if(info.direction=='down'){//prev Page
            scrollToElementById('span_alege_evenimentul',-25,300);
        }
    }

    handleSwipePage ({ evt, ...info }:any) {
        let vueInst=this;
        if(info.direction=='up'){//prev Page
            scrollToElementById('div_footer',-17,300);
        }
        if(info.direction=='down'){//prev Page
            scrollToElementById('span_alege_evenimentul',0,300);
        }
        if(info.direction=='left'){//prev Page
            vueInst.$refs.carousel_alegere_tip_donatie.next();
        }
        if(info.direction=='right'){//prev Page
            vueInst.$refs.carousel_alegere_tip_donatie.previous ();
        }
    }
}
